<template>
  <div class="article wrapper">
    <div class="vedio"></div>
    <div class="content" v-html="content"></div>
    <footerAct></footerAct>
  </div>
</template>
<script>
import { GetArticleByMenuId } from "@/api/index";
export default {
  data() {
    return {
      content: "",
      id: "",
      title: "",
    };
  },
  components: {},
  created(e) {
    console.log(this.$route);
    let params = this.$route.query;
    if (params) {
      this.id = params.id;
      // document.title = params.title || "";
    }
    console.log(this.id);
    if (this.id) {
      this.getArticleById();
    }
  },
  methods: {
    getArticleById() {
      GetArticleByMenuId(this.id)
        .then((res) => {
          this.content = res.article.C_CONTENT || "";
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding: 15px;
  white-space: pre-wrap;
  background: none;
  /deep/ p > img {
    width: 100%;
  }
}
.vedio {
  text-align: center;
  padding-top: 10px;
}
.article {
  // background: #fff;
  min-height: 100%;
}
</style>